<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" fill="none">
    <path
      d="M21.7278 19.2933L17.8342 15.3971C17.7466 15.3098 17.6425 15.2406 17.528 15.1937C17.4136 15.1468 17.2909 15.1229 17.1672 15.1237H16.5302C17.8029 13.4929 18.4056 11.438 18.2155 9.37818C18.0254 7.31832 17.0567 5.40854 15.507 4.03825C13.9573 2.66797 11.9434 1.94037 9.87571 2.00383C7.80806 2.06728 5.84248 2.91701 4.37974 4.37974C2.91701 5.84248 2.06728 7.80806 2.00383 9.87571C1.94037 11.9434 2.66797 13.9573 4.03825 15.507C5.40854 17.0567 7.31832 18.0254 9.37818 18.2155C11.438 18.4056 13.4929 17.8029 15.1237 16.5302V17.1672C15.1229 17.2909 15.1468 17.4136 15.1937 17.528C15.2406 17.6425 15.3098 17.7466 15.3971 17.8342L19.2933 21.7278C19.38 21.8152 19.4833 21.8845 19.5969 21.9318C19.7106 21.9791 19.8325 22.0034 19.9557 22.0034C20.0788 22.0034 20.2007 21.9791 20.3144 21.9318C20.4281 21.8845 20.5313 21.8152 20.6181 21.7278L21.7236 20.6223C21.8999 20.4463 21.9992 20.2077 22 19.9586C22.0008 19.7096 21.9029 19.4704 21.7278 19.2933ZM10.1211 15.1245C9.13172 15.1245 8.16454 14.8311 7.34188 14.2814C6.51922 13.7317 5.87803 12.9504 5.4994 12.0363C5.12077 11.1223 5.0217 10.1164 5.21473 9.14602C5.40775 8.17563 5.8842 7.28426 6.58381 6.58464C7.28343 5.88503 8.17479 5.40859 9.14519 5.21556C10.1156 5.02254 11.1214 5.1216 12.0355 5.50023C12.9496 5.87886 13.7309 6.52005 14.2806 7.34271C14.8303 8.16537 15.1237 9.13256 15.1237 10.122C15.1232 11.4484 14.596 12.7204 13.6579 13.6582C12.7198 14.596 11.4476 15.1228 10.1211 15.1228V15.1245Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: 'SearchIcon',
  props: {
    size: {
      type: Number,
      default: 24
    },
    color: {
      type: String,
      default: '#747474'
    }
  }
};
</script>
